module.exports = __webpack_public_path__ + "img/img04.48396c8d.png";